/* eslint-disable import/prefer-default-export */
import headers from "app/requests/headers";

export const get = () => (
  fetch("/api/admin/dashboard", {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);
